(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("seqviz", [], factory);
	else if(typeof exports === 'object')
		exports["seqviz"] = factory();
	else
		root["seqviz"] = factory();
})(this, () => {
return 